import React from 'react'
import {
  Divider,
  ecommerceLogoPack,
  IconManager,
  Link,
  Logo,
  Text,
  ThemeProvider,
  Box,
} from '@deseretbook/react-ui'

IconManager.register(ecommerceLogoPack)

const StorePickupLogo = () => (
  <ThemeProvider>
    <Box isColumn alignItems="center" paddingBottom={1}>
      <Text isItalic display="block" alignment="center">This product is available for</Text>
      <Box maxWidth={15} paddingTop={0.5}>
        <Link href="/free-pickup-in-store">
          <div>
            <Logo name="storePickup" />
          </div>
        </Link>
      </Box>
      <Divider />
      <Text display="block" alignment="center">Need this item faster? Check your local store's stock.</Text>
    </Box>
  </ThemeProvider>
)

export default StorePickupLogo
